  // VIGIA — reseta qualquer tentativa de zoom via CSS (zoom/transform: scale)
  // aplicada por outro script (app de terceiro) no html/body. Roda o tempo
  // todo, silenciosamente, e não afeta zoom de verdade do navegador (isso
  // nenhum site consegue controlar) — só neutraliza truques via CSS.
  (function watchZoom() {
    function resetZoom() {
      [document.documentElement, document.body].forEach(function (el) {
        if (el.style.zoom && el.style.zoom !== '1' && el.style.zoom !== '') {
          el.style.zoom = '';
        }
        if (el.style.transform && el.style.transform.indexOf('scale') !== -1) {
          el.style.transform = '';
        }
      });
    }
    resetZoom();
    setInterval(resetZoom, 500);
  })();

document.addEventListener('DOMContentLoaded', function () {
  // FAQ accordion
  document.querySelectorAll('.faq-question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq-item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(function (openItem) {
        openItem.classList.remove('open');
      });
      if (!isOpen) item.classList.add('open');
    });
  });

  // Photo lightbox
  var lightbox = document.getElementById('tour-lightbox');
  var lightboxImg = lightbox.querySelector('img');
  document.querySelectorAll('.tour-gallery-img').forEach(function (img) {
    img.addEventListener('click', function () {
      lightboxImg.src = img.dataset.full;
      lightboxImg.alt = img.alt;
      lightbox.hidden = false;
    });
  });
  lightbox.querySelector('.lightbox-close').addEventListener('click', function () {
    lightbox.hidden = true;
  });
  lightbox.addEventListener('click', function (e) {
    if (e.target === lightbox) lightbox.hidden = true;
  });

  // Troca de variante (Shared/Private x Adulto/Criança) atualiza o preço exibido
  var variantsJsonEl = document.getElementById('tour-variants-json');
  var priceDisplay = document.getElementById('tour-price-display');
  var optionSelects = document.querySelectorAll('.tour-variant-option');
  if (variantsJsonEl && optionSelects.length) {
    var variants = JSON.parse(variantsJsonEl.textContent);

    function formatMoney(cents) {
      return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }

    function updatePrice() {
      var selected = Array.prototype.map.call(optionSelects, function (sel) { return sel.value; });
      var match = variants.find(function (v) {
        return [v.option1, v.option2, v.option3]
          .filter(Boolean)
          .every(function (opt, i) { return opt === selected[i]; });
      });
      if (match && priceDisplay) {
        priceDisplay.textContent = formatMoney(match.price);
      }
    }

    optionSelects.forEach(function (sel) {
      sel.addEventListener('change', updatePrice);
    });
  }
});
